module.exports = __webpack_public_path__ + "static/spark_on_air_landscape-12f00298eea9e0819af96febd28fa73c.png";